import { I18N_TRANSLATIONS_BASE_PATH } from '../../constants/i18nConstants';
import { i18nConfigurationGeneral } from './i18nConfigurationGeneral';
const generateFrontEndI18nInitOptions = (version, loadPath = I18N_TRANSLATIONS_BASE_PATH) => (Object.assign(Object.assign(Object.assign(Object.assign({}, i18nConfigurationGeneral), { 
    // Report missing keys so i18n-client can lazily fetch the fallback language on demand.
    saveMissing: true, saveMissingTo: 'fallback' }), {
    cache: Object.assign(Object.assign({}, i18nConfigurationGeneral.cache), { enabled: true, versions: Object.keys(i18nConfigurationGeneral.supportedLngs).reduce((previous, current) => {
            previous[current] = version;
            return previous;
        }, {}) }),
}), {
    backend: Object.assign(Object.assign({}, i18nConfigurationGeneral.backend), { loadPath, parse: function (data) {
            return typeof data === 'string' ? JSON.parse(data) : data;
        } }),
}));
export default (version, loadPath = I18N_TRANSLATIONS_BASE_PATH) => generateFrontEndI18nInitOptions(version, loadPath);
